import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineLink } from '../../base/outline-link/outline-link';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-file-link.css.lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import '../../base/outline-icon/outline-icon';

/**
 * The SeFileLink component
 * @element se-file-link
 */
@customElement('se-file-link')
export class SeFileLink extends OutlineLink {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String })
  label: string;

  @property({ type: String, attribute: 'mime-type' })
  mimeType: string;

  @property({ type: String, attribute: 'file-size' })
  fileSize: string;

  iconTemplate() {
    let icon = 'file';
    switch (this.mimeType) {
      case 'application/pdf':
      case 'application/x-pdf':
      case 'application/x-bzpdf':
      case 'application/x-gzpdf':
      case 'applications/vnd.pdf':
      case 'application/acrobat':
      case 'application/x-google-chrome-pdf':
      case 'text/pdf':
      case 'text/x-pdf':
        icon = 'pdf';
        break;
      case 'application/msword':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
      case 'pplication/vnd.ms-word.document.macroEnabled.12':
      case 'application/vnd.ms-word.template.macroEnabled.12':
        icon = 'word';
        break;
      default:
        break;
    }
    return html`<outline-icon library="system" name="${icon}" size="1.5rem">
    </outline-icon> `;
  }

  render(): TemplateResult {
    return html`<a
      class="se-file-link"
      href=${this.linkHref}
      rel="${ifDefined(this.linkRel)}"
      target="${ifDefined(this.linkTarget)}"
      aria-label="${ifDefined(this.label)}"
      download
    >
      ${this.iconTemplate()}
      <span class="visually-hidden">Download</span>
      ${this.linkText ? html`${this.linkText}` : html`<slot></slot>`}
      ${this.fileSize
        ? html`<span class="se-file-link__file-size">(${this.fileSize})</span>`
        : ''}
    </a>`;
  }
}
